export default {
      id: "icon-tel-usage",
      viewBox: "0 0 31.619 32.824",
      url: __webpack_public_path__ + "icons.svg#icon-tel",
      toString: function () {
        return this.url;
      }
    }